import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { Row, Col } from 'reactstrap'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { fetchInteractions } from '../../../ducks/interactions'
import { fetchInteraction } from '../../../ducks/interaction'

import Filters from '../../Dashboard/Filters'
import InteractionsList from '../../Dashboard/InteractionsList'
import InteractionPage from './InteractionPage'

const StyledInteractionsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
`

class InteractionSection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      containerHeight: 500
    }

    this.containerRef = React.createRef()
    window.addEventListener('resize', this.onWindowResize)
  }

  componentDidMount() {
    this.onWindowResize()
  }

  componentDidUpdate() {
    this.onWindowResize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize)
  }

  onWindowResize = () => {
    const { containerHeight } = this.state

    const { innerHeight } = window
    const { top } = this.containerRef.current.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    const resultTop = top + scrollTop

    // TODO hardcoded -2
    const resultHeight =
      innerHeight - resultTop < 500 ? 500 : innerHeight - resultTop - 2

    if (containerHeight !== resultHeight) {
      this.setState({
        containerHeight: resultHeight
      })
    }
  }

  render() {
    const { containerHeight } = this.state

    return (
      <div ref={this.containerRef}>
        <StyledInteractionsWrapper>
          <InteractionsList containerHeight={containerHeight} />
          <Route
            path="/dashboard/interactions/:id"
            render={(props) => (
              <InteractionPage {...props} containerHeight={containerHeight} />
            )}
          />
        </StyledInteractionsWrapper>
      </div>
    )
  }
}

class InteractionsPage extends Component {
  componentDidMount() {
    if (!this.props.interactions.loading) {
      this.props.fetchInteractions()
    }
  }

  componentDidUpdate() {
    const { interaction, interactions, fetchInteraction } = this.props

    if (
      document.body.clientWidth > 992 &&
      interaction.selectedInteractionId === '' &&
      interactions.entities.length !== 0
    ) {
      const ticketId = interactions.entities[0].interaction_id

      fetchInteraction(ticketId)
    }
  }

  render() {
    return (
      <Row>
        <Col lg={12}>
          <Filters />
          <InteractionSection />
        </Col>
      </Row>
    )
  }
}

export default connect(
  ({ interactions, interaction }) => ({ interactions, interaction }),
  { fetchInteractions, fetchInteraction },
  null,
  { pure: false }
)(InteractionsPage)
